import * as React from "react";
const SvgUnset = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 512, height: 512, viewBox: "0 0 512 512", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 256, cy: 256, r: 256, fill: "transparent" }));
export default SvgUnset;
